/* eslint-disable react/no-danger */
// Modules
import React from 'react'
import { Link } from 'react-router-dom'

// Application
import Logo from 'assets/logo.svg'
import { LinkProps } from 'typings/components'

// Components
import { StyledHeader } from './styles'
import { RemoteLab } from 'typings/laboratory'

interface Props {
    boldText?: string
    link?: LinkProps
    subtitle?: string
    title?: string
    showDot?: boolean
    logoAux?: RemoteLab
    showNavBrand?: boolean
}

export const Header: React.FC<Props> = ({
    showDot = true,
    showNavBrand = true,
    title = '',
    link,
    subtitle = '',
    boldText,
    logoAux,
}) => (
    <StyledHeader
        className={[
            logoAux ? 'Header--with-logo' : 'Header--without-logo',
            showNavBrand ? 'Header--with-brand' : 'Header--without-brand',
        ].join(' ')}
    >
        {showNavBrand && (
            <header>
                {showNavBrand && <img alt="" className="header__image" src={Logo} />}
                {logoAux && (
                    <>
                        <div className="divider" />
                        <img alt={logoAux.name} className="header__image" src={logoAux.image} />
                    </>
                )}
            </header>
        )}
        {title && (
            <h1 className="header__title" data-testid="title-header" title={title}>
                {title}
            </h1>
        )}
        {subtitle && <p dangerouslySetInnerHTML={{ __html: subtitle }} />}
        {(boldText || link) && (
            <div className="header__subtitle" data-testid="subtitle-header">
                {boldText && <span>{` ${boldText}${showDot ? '.' : ''}`}</span>}
                {link && (
                    <Link className="header__subtitle__link" data-testid="title-link" to={link.to}>
                        {link.text}
                    </Link>
                )}
            </div>
        )}
    </StyledHeader>
)
